/* eslint-disable no-useless-concat */
import React from "react";
import Label from './LabelUtilsComponet'
import Required from './RequiredComponent'

const RadioButton = ({ config, onChange }) => {
  return (
    <div className={config.classContainer}>
            <Label {...config} />
      <div className="div-checkbox-form">
        {config.data.map((item, index) => {
          return (
            <div
              key={`rb_${config.variable}_${index}`}
              className={config.classInput}
              onClick={() => onChange(config.variable, item[config.keyValue], config.type)}
            >
              {
                config.value === item[config.keyValue] ?
                  <i className="far fa-check-circle fa-1x5"></i> :
                  <i className="far fa-circle fa-1x5"></i>
              }
                &nbsp;{item[config.keyText]}
            </div>

          );
        })}
      </div>
        {
          <Required {...config} msg="Seleccione un elemento" />
        }
    </div>
  )
}

export default RadioButton;
